import FormattedMessage from 'I18n/components/FormattedMessage';
import { HubMerchCardLayoutUI } from '../../containers/merch-card/HubMerchCardLayoutUI';
import { jsx as _jsx } from "react/jsx-runtime";
export const MarketingPlusMerchCards = () => {
  const productsConfig = {
    PROFESSIONAL: {
      apiName: 'marketing-plus-professional-bundle',
      Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.marketingPlus.professionalCard.description"
      }),
      lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.marketingPlus.professional.lowerTierPlus"
      })
    },
    ENTERPRISE: {
      apiName: 'marketing-plus-enterprise-bundle',
      Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.marketingPlus.enterpriseCard.description"
      }),
      lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.marketingPlus.enterprise.lowerTierPlus"
      })
    }
  };
  return /*#__PURE__*/_jsx(HubMerchCardLayoutUI, {
    productsConfig: productsConfig
  });
};